// react
import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated } from "beaktShared/helpers/masks";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function ProdutosForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors, clearError, getValues } = useForm({ mode: "onChange" });
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);
    const [controlaEstoqueCheckbox, setcontrolaEstoqueCheckbox] = React.useState(false);
    const [bloqueadoVenda, setBloqueadoVenda] = React.useState(false);
    const [incluirRoyaltieCheckbox, setIncluirRoyaltieCheckbox] = React.useState(true);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ""
    });

    useEffect(() => {
        UseGetApiSimple("Franquias/GetByEstabelecimento/" + session.estabelecimentoId).then((result) => {
            if (result.status == 200) {
                session.franquiaId = result.data.franquiaId;
                if (!item.produtoId && session.franquiaId === 1) {
                    setNotification({
                        show: true,
                        message: "Ao adquirir Semaglutida/Tirzepatida, é obrigatória a assinatura do serviço de telemedicina para prescrição e acompanhamento."
                    });
                }
            }
        });

    }, [item])

    const intialValues = {
        id: 0,
        descricao: '',
        valor: '',
        valorcusto: ''
    };

    useEffect(() => {
        LoadSelectProdutoGrupo();
        if (session.estabelecimentoId === 0) {
            setshowSelectEstabelecimento(true);
            loadSelectEstabelecimentos();
        }
    }, []);

    const [produtoGrupo, setprodutoGrupo] = React.useState("");
    const [listSelectProdutoGrupo, setlistSelectProdutoGrupo] = React.useState([]);
    const [loadingSelectProdutoGrupo, setloadingSelectProdutoGrupo] = React.useState(false);
    const getEndPointProdutoGrupo = () => {
        let endPointGet = "";
        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet = "produtogrupos/ativos/byfranquia/" + session.franquiaId;
        else //Acessando tela pelo modulo Clinica ou Agenda  
            endPointGet = "produtogrupos/ativos/byestabelecimento/" + session.estabelecimentoId;
        return endPointGet;
    }
    const LoadSelectProdutoGrupo = () => {
        setloadingSelectProdutoGrupo(true);
        const endPoint = getEndPointProdutoGrupo();
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectProdutoGrupo(false);
                return false;
            }
            setlistSelectProdutoGrupo(result.data);
            setloadingSelectProdutoGrupo(false);
            return true;
        });
    }
    const handleProdutoGrupoChange = event => {
        let value = event
        setprodutoGrupo(value);
        setValue("produtoGrupo", value);
        if (value !== "")
            clearError("produtoGrupo");
    };

    const [showSelectEstabelecimento, setshowSelectEstabelecimento] = React.useState(false);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
    const loadSelectEstabelecimentos = () => {
        setloadingSelectEstabelecimentos(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectEstabelecimentos(false);
                return false;
            }
            setlistSelectEstabelecimentos(result.data);
            setloadingSelectEstabelecimentos(false);
            return true;
        });
    }
    const handleEstabelecimentoChange = event => {
        let value = event
        let data = getValues()

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId,
                produtoId: data.id
            });
        });
        setestabelecimentos(lstsAdd);
        setlistEstabelecimentosSelected(lstSelect);

    };
    const handleClickSelecionarTodosEstabelecimentos = () => {

        let data = getValues()
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId,
                produtoId: data.id
            });
        });
        setestabelecimentos(lstsAdd);
        setlistEstabelecimentosSelected(lstSelect);
    }

    const [boletimOcorrencia, setboletimOcorrencia] = React.useState(null);
    const loadBoletimOcorrencia = () => {
        UseGetApiSimple("boletimocorrencia/ultimoboletimproduto/" + item.produtoId, 0).then(result => {
            if (result.status !== 200) {
                return false;
            }
            if (result.data != null && result.data.aprovado != true) {
                setboletimOcorrencia({
                    color: result.data.aprovado == null ? "warning" : "danger",
                    message: result.data.aprovado == null ? "Aguardando Aprovação da Matriz" : ("Produto Bloqueado pela Matriz: " + result.data.motivoReprova),
                })
            }
        });
    }

    useEffect(() => {
        if (!item.produtoId)
            return;
        setValue('id', item.produtoId);
        setValue('descricao', item.descricao);
        setValue("produtoGrupo", item.produtoGrupoId);
        setprodutoGrupo(item.produtoGrupoId);
        setAtivoCheckbox(item.ativo);
        setcontrolaEstoqueCheckbox(item.controlaEstoque);
        let valor = transformValueFloattoFormated(item.valor);
        setValue("valor", valor);
        let valorcusto = transformValueFloattoFormated(item.valorCusto);
        setValue("valorcusto", valorcusto);
        loadEstabelecimentoProdutos(item.produtoId);
        loadBoletimOcorrencia();
        setBloqueadoVenda(item.bloqueadoVenda);
        setIncluirRoyaltieCheckbox(item.incluirRoyaltie);
    }, [item]);

    const loadEstabelecimentoProdutos = (idProduto) => {
        setloadingSelectEstabelecimentos(true);
        const endPoint = "produtos/" + idProduto;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectEstabelecimentos(false);
                return false;
            }
            loadSelectEstabelecimentoView(result.data.estabelecimentoProdutos);
            setloadingSelectEstabelecimentos(false);
            return true;
        });
    }

    const loadSelectEstabelecimentoView = (estabelecimentoProdutos) => {
        if (estabelecimentoProdutos === null)
            return;

        setlistEstabelecimentosSelected(estabelecimentoProdutos);

        let lstAdd = [];
        estabelecimentoProdutos.map(item => {
            lstAdd.push(item.estabelecimentoId);
        });
        setestabelecimentos(lstAdd);
    }

    const onSubmit = data => {
        let valor = transformValueFormatedtoFloat(data.valor);
        let valorcusto = transformValueFormatedtoFloat(data.valorcusto);
        addItem({
            produtoId: parseInt(data.id),
            descricao: data.descricao,
            produtoGrupoId: data.produtoGrupo,
            valor: valor,
            valorCusto: valorcusto,
            ativo: ativoCheckbox,
            bloqueadoVenda: bloqueadoVenda,
            controlaEstoque: controlaEstoqueCheckbox,
            usuarioCadastroId: session.id,
            estabelecimentoProdutos: loadEstabelecimentosProdutos(),
            incluirRoyaltie: incluirRoyaltieCheckbox,
            ...loadDadosMatriz()
        });
    };

    const loadDadosMatriz = () => {

        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            let temp = {
                cadastradoFranquia: true,
                franquiaId: session.franquiaId
            }
            return temp;
        }
        else {
            let temp = {
                cadastradoFranquia: false,
            }
            return temp;
        }
    }

    const loadEstabelecimentosProdutos = () => {

        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            return listSelectEstabelecimentosSelected;
        }
        else {
            let data = getValues()
            var estabelecimentoProdutos = [
                {
                    produtoId: parseInt(data.id),
                    estabelecimentoId: session.estabelecimentoId
                }
            ];
            return estabelecimentoProdutos;
        }
    }

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        {notification.show && <SnackbarContent
                            color={notification.color}
                            message={notification.message}
                            closeNotification={() => setNotification({ show: false })}
                            close
                        />}
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('information_message.product_registration')} - <small>{t('information_message.fill_in_your_details')}</small>
                                    <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    {boletimOcorrencia != null &&
                                        <GridItem xs={12} sm={12} md={12}>
                                            <SnackbarContent
                                                message={boletimOcorrencia == null ? "" : boletimOcorrencia.message}
                                                close
                                                color={boletimOcorrencia == null ? "success" : boletimOcorrencia.color}
                                            />
                                        </GridItem>
                                    }
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                disabled={(item.produtoId !== 0 && item.cadastradoFranquia === false && session.estabelecimentoId !== 0) ? true : false}
                                                error={errors.descricao ? true : false}
                                                label={t('label.description') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="descricao"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 150 }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.descricao && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>

                                        <FormControl fullWidth className={classes.formControl}>

                                            <label className={errors.produtoGrupo ? "select__label select__label_error" : "select__label"}>{t('information_message.product_group') + " *"} </label>

                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.produtoGrupo ? true : false)}
                                                isSearchable={true}
                                                isLoading={loadingSelectProdutoGrupo}
                                                name="produtoGrupo"
                                                placeholder={t('label.select') + " ..."}
                                                options={listSelectProdutoGrupo}
                                                value={listSelectProdutoGrupo.filter(({ produtoGrupoId }) => produtoGrupoId === produtoGrupo)}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ produtoGrupoId }) => produtoGrupoId}
                                                onChange={(value) => handleProdutoGrupoChange(value.produtoGrupoId !== null ? value.produtoGrupoId : "")}
                                                ref={() => register(
                                                    { name: "produtoGrupo" },
                                                    { required: true })
                                                }
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.produtoGrupo && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>



                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                label={t('label.value') + " *"}
                                                name="valor"
                                                inputRef={register({ required: true })}
                                                error={errors.valor ? true : false}
                                                defaultValue={intialValues.valor}
                                                InputProps={{
                                                    inputComponent: MaskMoney,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.valor && <span> {t('label.required')} </span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                label={t('label.value_cost') + " *"}
                                                name="valorcusto"
                                                inputRef={register({ required: true })}
                                                error={errors.valorcusto ? true : false}
                                                defaultValue={intialValues.valorcusto}
                                                InputProps={{
                                                    inputComponent: MaskMoney,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.valorcusto && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>

                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={4} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={ativoCheckbox}
                                                    onClick={event => { setAtivoCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{ checked: classes.checked, root: classes.checkRoot }}
                                                    name="ativo"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{ label: classes.label, root: classes.labelRoot }}
                                            label={t('information_message.is_the_product_active_in_the_system')}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={4} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={controlaEstoqueCheckbox}
                                                    onClick={event => { setcontrolaEstoqueCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{ checked: classes.checked, root: classes.checkRoot }}
                                                    name="controlaestoque"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{ label: classes.label, root: classes.labelRoot }}
                                            label={t('information_message.does_the_product_control_stock')}
                                        />
                                    </GridItem>
                                    
                                    {
                                        session?.habilitaControleRoyalties &&
                                        <GridItem xs={12} sm={4} md={4}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        tabIndex={-1}
                                                        checked={incluirRoyaltieCheckbox}
                                                        onClick={event => { setIncluirRoyaltieCheckbox(event.target.checked) }}
                                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                                        icon={<Check className={classes.uncheckedIcon} />}
                                                        classes={{ checked: classes.checked, root: classes.checkRoot }}
                                                        name="incluirRoyaltie"
                                                        inputRef={register}
                                                    />
                                                }
                                                classes={{ label: classes.label, root: classes.labelRoot }}
                                                label={t('information_message.does_the_product_control_royalts')}
                                            />
                                        </GridItem>
                                    }

                                </GridContainer>
                                <GridContainer>
                                    {showSelectEstabelecimento &&
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div style={{ border: '1px dashed #ccc', padding: '20px' }}>

                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <h3>{t('label.access_establishments')}</h3>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6} style={{ textAlign: 'right' }}>
                                                        <Button color="primary" round onClick={() => handleClickSelecionarTodosEstabelecimentos()}   >
                                                            {t('label.select_all_establishments')}
                                                        </Button>
                                                    </GridItem>
                                                </GridContainer>

                                                <br />
                                                <FormControl fullWidth className={classes.formControl}>

                                                    <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>{t('label.establishment')}</label>
                                                    {loadingSelectEstabelecimentos && <div className="loadingitemVenda">
                                                        <CircularProgress size={20} />
                                                    </div>}
                                                    {!loadingSelectEstabelecimentos &&
                                                        <Select
                                                            classNamePrefix="select"
                                                            isSearchable={true}
                                                            placeholder="Selecione..."
                                                            isMulti={true}
                                                            name="estabelecimentos"
                                                            isLoading={loadingSelectEstabelecimentos}
                                                            options={listSelectEstabelecimentos}
                                                            getOptionLabel={({ descricao }) => descricao}
                                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                            value={listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                                            onChange={(value) => handleEstabelecimentoChange(value || [])}
                                                            ref={() => register({ name: "estabelecimentos" })}
                                                        />
                                                    }
                                                    <FormHelperText className={classes.labelRootError}>
                                                        {errors.estabelecimentos && <span>{t('label.required')}</span>}
                                                    </FormHelperText>
                                                </FormControl>
                                            </div>
                                        </GridItem>}
                                </GridContainer>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <br />
                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}
                                {loading && <div>{t('label.loading') + "..."}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}